import React from 'react';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { EmptyList } from '@components/UIKit/EmptyList/EmptyList';
import { Pagination } from '@components/UIKit/Pagination/Pagination';
import s from './PaginatedList.module.scss';
interface PaginatedListProps<T> {
  data?: {
    items: T[];
    totalPages: number;
  };
  children: (props: T, index: number) => React.ReactNode;
  currentPage: number;
  onPageChange: (page: number) => void;
  status: 'error' | 'loading' | 'success';
  EmptyComponent?: () => JSX.Element | null;
  listClassName?: string;
  staticItemBeforeList?: JSX.Element;
  staticItemAfterList?: JSX.Element;
}
export const PaginatedList = <T extends Record<'id', number>,>({
  data,
  children,
  currentPage,
  onPageChange,
  status,
  EmptyComponent,
  listClassName,
  staticItemBeforeList,
  staticItemAfterList
}: PaginatedListProps<T>) => {
  if (status === 'loading') {
    return <div className={s.paginatedListWrapper}>
                <LogoLoader />
            </div>;
  }
  if (status === 'success' && !data?.items.length || status === 'error') {
    return EmptyComponent ? <EmptyComponent /> : <EmptyList />;
  }
  return <div className={s.paginatedListWrapper} data-sentry-component="PaginatedList" data-sentry-source-file="PaginatedList.tsx">
            <div className={listClassName}>
                {typeof staticItemBeforeList !== 'undefined' && staticItemBeforeList}
                {data?.items.map((item, index) => <React.Fragment key={item.id}>
                        {children(item, index)}
                    </React.Fragment>)}
                {typeof staticItemAfterList !== 'undefined' && staticItemAfterList}
            </div>
            
            {data?.totalPages && data.totalPages > 1 && <Pagination currentPage={currentPage} totalPages={data.totalPages} onPageChange={onPageChange} />}
        </div>;
};